export default {
    familias: [],
    familia: {}
}